import React, { useCallback, lazy, Suspense } from 'react';
import cn from 'classnames';
import { observer, calculatorState as store, modal as modalStore, storage } from 'store';
import Modal from 'components/UI/Modal';
import CloseButton from 'components/UI/CloseButton';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import Loader from 'components/UI/Loader';
import TagsLayout from './TagsLayout';
import Accordion from './Accordion';
import AsideFooter from './AsideFooter';
import { useOpenModalEventHandler } from 'components/Modals';
import { getFormData } from '../../utils';
import { useTrans } from 'utils/localisation';

import * as styles from './ResultModal.module.scss';

const CorporateForm = lazy(() => import('components/Forms/CorporateForm/CorporateForm'));

function ResultModal({ calculatorID, formName, sections, deviceType, counter }) {
  const { modal } = store.calculators[calculatorID];
  const { toggleModal, clearCalculatorInfo } = store;
  const t = useTrans(['common', 'calculator']);

  const closeModal = useCallback(() => {
    toggleModal(calculatorID, false);
  }, [toggleModal]);

  const onSuccess = useCallback(async () => {
    clearCalculatorInfo(calculatorID);
    toggleModal(calculatorID, false);
    modalStore.open('SuccessModal');
    storage.addItem('isEmailCheckedSuccessful', false);
  }, [clearCalculatorInfo, toggleModal]);

  useOpenModalEventHandler(modal.show, 'calculator');

  if (!modal.show) return null;
  return (
    <>
      <Modal
        isOpen={modal.show}
        containerMod="xlarge"
        closeButton={false}
        closeModalCallback={closeModal}
      >
        {onClose => (
          <>
            <CloseButton onClose={onClose} theme="dark" />
            <div className={deviceType === 'desktop' ? styles.layout : null}>
              {deviceType === 'mobile' && (
                <Accordion calculatorID={calculatorID} counter={counter} deviceType={deviceType} />
              )}
              <div className={cn(styles.wrapper, deviceType === 'desktop' && styles.left)}>
                {deviceType === 'desktop' && (
                  <>
                    <Title tag="h3">{t('resultModalTitle')}</Title>
                    <Subtitle className={styles.subtitle}>{t('resultModalSubtitle')}</Subtitle>
                  </>
                )}
                <Suspense fallback={<Loader theme="block" />}>
                  <CorporateForm
                    id={calculatorID}
                    formName={formName}
                    className={styles.form}
                    onSuccess={onSuccess}
                    closeModal={onClose}
                    getAdditionalFormData={() => ({
                      calculatorData: {
                        ...getFormData(calculatorID, sections),
                      },
                    })}
                    ndaPositionTop={true}
                    inModal={true}
                    theme="calculator"
                  />
                </Suspense>
              </div>
              <div
                className={cn(
                  deviceType === 'mobile' && styles.hidden,
                  styles.wrapper,
                  styles.right,
                )}
              >
                <TagsLayout calculatorID={calculatorID} counter={counter} deviceType={deviceType} />
                {deviceType === 'desktop' && <AsideFooter />}
              </div>
            </div>
          </>
        )}
      </Modal>
    </>
  );
}

export default observer(ResultModal);
